var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vertbar-container"},[_c('div',[_c('canvas',{attrs:{"height":"230","id":_vm.chartName}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }